import React, { useState, useEffect } from "react";
import Select from "react-select";
import "./Slider.css";
import { PiDressBold } from "react-icons/pi";
import {
  MdOutlineLocalFlorist,
  MdOutlineCake,
  MdOutlinePhotoCamera,
} from "react-icons/md";
import { GiMusicalNotes } from "react-icons/gi";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  ShowAllServiceLocation,
  ShowAllCategories,
} from "../../../../context/Slice/VendorManagementSlice";
import { SearchServices } from "../../../../context/Slice/ServiceManagementSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import {
  faLocationDot,
  MdOutlinePlace,
  GiPartyPopper,
  GiHennaTattoo,
  GiLipstick,
  MdOutlineRestaurant,
} from "@fortawesome/free-solid-svg-icons";
import {
  Place,
  Celebration,
  Brush,
  FaceRetouchingNatural,
  Restaurant,
} from "@mui/icons-material";
import { toast } from "react-toastify";

const Slider = () => {
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.VendorManagementR.AllLoc);
  const categories = useSelector((state) => state.VendorManagementR.AllCat);
  const SearchData = useSelector((state) => state.ServiceManagementR.Data);

  let navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);

  useEffect(() => {
    dispatch(ShowAllServiceLocation());
    dispatch(ShowAllCategories());
  }, [dispatch]);

  const handleCategoryChange = (option) => {
    setSelectedCategory(option);
  };

  const handleLocationChange = (option) => {
    setSelectedLocation(option);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   
  
    try {
      const response = await dispatch(
        SearchServices(
          {
            CategorieName: selectedCategory?.label,
            ServiceLocations: selectedLocation?.label,
          } 
        )
      );
      
    
      if (response?.payload?.VendorServices) {
        // Filter results based on status === "approved"
        const approvedServices = response.payload.VendorServices.filter(
          (service) => service.status === "approved"
        );
  
        if (approvedServices.length > 0) {
          navigate(
            `/vendor-list1?category=${selectedCategory?.label}&location=${selectedLocation?.label}`
          );
        } else {
          toast.error("No services found.");
        }
      } else {
        toast.error("No data returned from search.");
      }
    } catch (error) {
      console.error("Search error:", error); // Logs full error in console
      toast.error(`Search error: ${error.message || error.toString()}`);
    }
  };
  

  return (
    <div className="slider-top">
      <div id="myCarousel" className="carousel slide" data-ride="carousel">
        <div className="carousel-inner">
          <div className="item active">
            <img src="assets/Images/mainSliders/slider-1.jpg" alt="Kolkata" />
          </div>
          <div className="item">
            <img src="assets/Images/mainSliders/slider-2.jpg" alt="Chennai" />
          </div>
        </div>
        <a
          className="left carousel-control"
          href="#myCarousel"
          data-slide="prev"
        >
          <span className="glyphicon glyphicon-chevron-left"></span>
          <span className="sr-only">Previous</span>
        </a>
        <a
          className="right carousel-control"
          href="#myCarousel"
          data-slide="next"
        >
          <span className="glyphicon glyphicon-chevron-right"></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
      <div className="slider-content">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-12 mx-auto">
              <h1>Find the Perfect Wedding Vendor</h1>
              <p className="lead text-white text-center">
              Search for professional wedding vendors with reviews, pricing, availability, and more
              </p>
              <form onSubmit={handleSubmit}>
                <div className="slider-form rounded">
                  <div className="row align-items-center g-0">
                    <div className="col-md-10">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <div className="">
                            <div className="input-group">
                              <span className="d-flex align-items-center px-3 before-input-box">
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                              </span>

                              <Select
                                className="form-control form-light listing-category category-input"
                                placeholder="Select category"
                                options={categories.map((category) => ({
                                  label: category.CategorieName.toUpperCase(),
                                  value: category.id,
                                }))}
                                onChange={handleCategoryChange}
                                menuPortalTarget={document.body} // Render dropdown at body level
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }), // Ensure high z-index
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 left-border">
                          <div className="">
                            <div className="input-group">
                              <span className="d-flex align-items-center px-3 before-input-box fs-5">
                                <FontAwesomeIcon icon={faLocationDot} />
                              </span>
                              <Select
                                className="form-control form-light listing-category category-input"
                                placeholder="Select Location"
                                options={locations.map((location) => ({
                                  value: location.LocationName.toUpperCase(),
                                  label: location.LocationName.toUpperCase(),
                                }))}
                                onChange={handleLocationChange}
                                menuPortalTarget={document.body} // Render dropdown at body level
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }), // Ensure high z-index
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="d-grid">
                        <button
                          type="submit"
                          className="btn btn-default text-nowrap btn-block"
                        >
                          Search Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <p className="lead text-white text-center ">
                Or browse featured categories
              </p>
              <div className="slider-category listing-category-layout-1">
                {/* <a href="listing-category/cake/index.html">
    <i><MdOutlineCake /></i> Cake
  </a>
  <a href="listing-category/dress">
    <i><PiDressBold /></i> Dress
  </a>
  <a href="listing-category/florist/index.html">
    <i><MdOutlineLocalFlorist /></i> Florist
  </a>
  <a href="listing-category/music/index.html">
    <i><GiMusicalNotes /></i> Music
  </a> */}
                <a href="/vendor-list?category=PHOTOGRAPHERS">
                  <i>
                    <MdOutlinePhotoCamera />
                  </i>{" "}
                  Photographer
                </a>
                <a href="/vendor-list?category=VENUE">
                  <i>
                    <Place />
                  </i>{" "}
                  Venues
                </a>
                <a href="/vendor-list?category=DECORATORS">
                  <i>
                    <Celebration />
                  </i>{" "}
                  Decorators
                </a>
                <a href="/vendor-list?category=MEHANDI%20ARTIST">
                  <i>
                    <Brush />
                  </i>{" "}
                  Mehandi
                </a>
                <a href="/vendor-list?category=BRIDAL%20MAKEUP">
                  <i>
                    <FaceRetouchingNatural />
                  </i>{" "}
                  Bridal Makeup Artists
                </a>
                <a href="/vendor-list?category=WEDDING%20CATERERS">
                  <i>
                    <Restaurant />
                  </i>{" "}
                  Caterers
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slider;
